export const intro = (introRan,isHomepage,isEdition) => {

  const introelement = document.getElementById('intro');
  const artwork =  document.getElementById('lines');
  const push  = document.getElementById('push');

  const init = () => {
    
    if(introRan) {
      if(isHomepage == true || isEdition == true) {
        console.log('This page contains intro element')
        introelement.style.display = "block";
        push.style.display = "block";
      } else {
        console.log('Hide the intro')
        introelement.style.display = "none";
        push.style.display = "none";
      }
    }

    if (introRan == false) {
      bind();
    }

  };

  const bind = () => {


    // const introelement  = document.querySelector(intro);
    let introheight = push.offsetHeight;
    let destroyed = false;

    function setIntroHeight() {
      introheight = push.offsetHeight;
      push.style.height = introheight - window.pageYOffset;
      artwork.style.height = introheight - window.pageYOffset;
    }

    function showIntroLines() {
      artwork.classList.add('is-initialised');
    }

 
    // function destroyIntro() {
    //   if(destroyed == false) {
    //
    //     // artwork.style.height = 0;
    //     push.style.height = 0;
    //     window.scrollTo(0, 0);
    //     destroyed = true;
    //   }
    // }

    // function hideIntro() {
    //   introelement.remove();
    // }

    ;(function() {
        var throttle = function(type, name, obj) {
            var obj = obj || window;
            var running = false;
            var func = function() {
                if (running) { return; }
                running = true;
                requestAnimationFrame(function() {
                    obj.dispatchEvent(new CustomEvent(name));
                    running = false;
                });
            };
            obj.addEventListener(type, func);
        };
        throttle ("scroll", "optimizedScroll");
    })();

    window.addEventListener('resize', function() {
      setIntroHeight();
    });
    
    // to use the script *without* anti-jank, set the event to "scroll" and remove the anonymous function.
    window.addEventListener("optimizedScroll", function() {
     if( window.pageYOffset < introheight ) {
      setIntroHeight();
     }

     if( introheight - window.pageYOffset < 0 ) {
       // destroyIntro();
       introelement.classList.add('is-hidden');
     } else {
       introelement.classList.remove('is-hidden');
     }

    });

    setIntroHeight();
    showIntroLines();

  };

  if (typeof(introelement) != 'undefined' && introelement != null) {
    init();
  }

};
